import { FC, useState } from 'react';
import StudentLearnExperienceCard from './StudentLearnExperienceCard';
import StudentLearnExperienceModal, { optionModal } from './Modal/StudentLearnExperienceModal';

const StudentCardData = [
  {
    title: (
      <>
        Students land on a <span className="tw-text-indigo-600">personalized</span> path
      </>
    ),
    subtitle: "Each student begins on their own path of skills, built around what they're ready for.",
    img: '/student-experience-1.png',
    color: 'indigo-400',
    letter: 'A',
  },
  {
    title: (
      <>
        Every path is made of <span className="tw-text-purple-600">Skills</span>
      </>
    ),
    subtitle: 'Those skills are the building blocks of every path, and where students do most of their learning.',
    img: '/student-experience-2.png',
    color: 'purple-400',
    letter: 'B',
  },
  {
    title: (
      <>
        Each skill follows <span className="tw-text-sky-600">4 steps</span>
      </>
    ),
    subtitle:
      'Students build context, then learn, practice, and demonstrate their understanding - the same steps every time.',
    img: '/student-experience-3.png',
    color: 'sky-400',
    letter: 'C',
  },
];

const StudentLearnExperience: FC = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [option, setOption] = useState<optionModal>(optionModal.FIRST);

  return (
    <>
      <div className="nc_student-learn-experience">
        <h1 className="tw-text-lg tw-font-atkinson tw-font-bold tw-text-stone-800">
          The ABCs of the student experience
        </h1>
        <p className="tw-text-sm tw-font-atkinson tw-text-stone-600 tw-m-0">
          Before students dive in, know what they&apos;ll experience to guide them <br></br> and answer questions
          confidently.
        </p>
        <div className="tw-flex tw-flex-row tw-gap-x-10">
          <StudentLearnExperienceCard data={StudentCardData[0]} setOption={setOption} setVisible={setVisible} />
          <StudentLearnExperienceCard data={StudentCardData[1]} setOption={setOption} setVisible={setVisible} />
          <StudentLearnExperienceCard data={StudentCardData[2]} setOption={setOption} setVisible={setVisible} />
        </div>
      </div>
      {visible && (
        <StudentLearnExperienceModal setOption={setOption} option={option} setVisible={setVisible} visible={visible} />
      )}
    </>
  );
};

export default StudentLearnExperience;
